import React, { useEffect, useState, useContext } from 'react';
import Modal from 'react-modal';
import "./style.scss";
import TableComponent from "../../../../../../../../generic/table/TableComponent";
import { FilterContext } from '../../../../../../../../../providers/filterData-provider';
import { useSelector } from 'react-redux';
import ApplicationListDrilldown from './drilldown/ApplicationListDrilldown';
import { useFetch } from '../../../../../../../../../hooks';

const ApplicationDetails = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [applicationDetails, setApplicationDetails] = useState([]);
  const { selectedLendFilterValues } = useContext(FilterContext);
  const lendFilterList = useSelector(state => state?.lendFilter?.data);
  const [limit, setLimit] = useState(20);
  const [sortParams, setSortParams] = useState([]);

  const { api } = useFetch();

  const handleToggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const filterData = Object.keys(selectedLendFilterValues)?.map(key => {
    const filterConfig = lendFilterList?.find(ele => ele?.FILTER_ID === key);

    if (key === 'from' || key === 'to') {
      const dateFilterData = lendFilterList?.find(ele => ele?.DISPLAY_TYPE === 'DATE_PICKER');
      if (dateFilterData) {
        return {
          id: `${dateFilterData.BASE_TABLE}.${dateFilterData.BASE_COLUMN}`,
          datatype: 'DATE',
          value: {
            from: selectedLendFilterValues.from,
            to: selectedLendFilterValues.to
          }
        }
      }
    } else if (filterConfig) {
      const filterValues = Array.isArray(selectedLendFilterValues[key])
        ? selectedLendFilterValues[key] : [selectedLendFilterValues[key]];

      return filterValues?.map(value => ({
        id: `${filterConfig.BASE_TABLE}.${filterConfig.BASE_COLUMN}`,
        value
      }))
    }
    return null;
  }).flat().filter(Boolean);

  // const fetchApplicationDetails = async (filterData = [], sort = [], limit = 10) => {
  //   try {
  //     const applicationDetailsAPI = `${process.env.REACT_APP_BASE_URL}/api/dashboard/lend/charts/applications-details`;
  //     const payload = {
  //       filter: filterData?.length > 0 ? filterData : [],
  //       sort: sort?.length > 0 ? sort : [],
  //       limit: limit,
  //     }
  //     const response = await axios.post(applicationDetailsAPI, payload);
  //     setApplicationDetails(response.data.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  const fetchApplicationDetails = async (filterData = [], sort = [], limit = 10) => {
    const applicationDetailsAPI = `${process.env.REACT_APP_BASE_URL}/api/dashboard/lend/charts/applications-details`;
    const payload = {
      filter: filterData?.length > 0 ? filterData : [],
      sort: sort?.length > 0 ? sort : [],
      limit: limit,
    }
    const { data } = await api(applicationDetailsAPI, 'POST', payload);
    setApplicationDetails(data);
  }

  useEffect(() => {
    fetchApplicationDetails(filterData, sortParams, limit);
  }, [selectedLendFilterValues, sortParams, limit]);

  const handleSort = (column, order) => {
    const newSortParams = [{ id: column, value: order }];
    setSortParams(newSortParams);
  };

  const handleScroll = () => {
    setLimit(prevLimit => prevLimit + 10);
  }

  return (
    <div className='application-container'>
      <div className='application-container__header'>
        <h1>Applications</h1>
        <div className='application-container__header__arrow' onClick={handleToggleModal}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>

        </div>
      </div>
      <div className='application-container__table'>
        <TableComponent tableData={applicationDetails?.slice(0, 6)} onSort={handleSort} />
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleToggleModal}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            'border-radius': '10px',
            background: 'var(--dark- grey, #100F0F)'
          },
          content: {
            background: 'var(--dark-grey, #100F0F)',
            width: '900px',
            height: '550px',
            color: "white",
            top: "50%",
            left: "50%",
            transform: 'translate(-50%, -50%)',
            borderRadius: '15px',
            border: "none",
            overflowY: "hidden",
            fontSize:"20px"
          },
        }}
      >
        <ApplicationListDrilldown tableData={applicationDetails} onSort={handleSort} handleScroll={handleScroll} handleToggleModal={handleToggleModal} />
      </Modal>
    </div >
  );
};

export default ApplicationDetails;

